import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

// Shown instead of the empty state when a list failed to load,
// so an outage is never mistaken for "no data".
export const LoadError = ({ message, onRetry }) => (
    <Card className="bg-card border-border" role="alert">
        <CardContent className="flex flex-col items-center justify-center py-16">
            <AlertTriangle className="w-12 h-12 text-destructive-text mb-4" aria-hidden="true" />
            <h3 className="font-heading text-xl font-semibold mb-2">
                Chargement impossible
            </h3>
            <p className="text-muted-foreground text-center max-w-md mb-6">
                {message}
            </p>
            <Button variant="outline" onClick={onRetry}>
                <RefreshCw className="w-4 h-4 mr-2" />
                Réessayer
            </Button>
        </CardContent>
    </Card>
);
